export function getNStatusLabel(
    nStatus?: "red" | "yellow" | "green",
    t?: (key: string) => string,
) {
    if (!nStatus) {
        return undefined;
    }

    const labels = {
        red: t ? t("n_status.deficient") : "Deficient",
        yellow: t
            ? t("n_status.approaching_deficiency")
            : "Approaching Deficiency",
        green: t ? t("n_status.sufficient") : "Sufficient",
    };

    return labels[nStatus];
}
